import {
  NodeUtils,
  createBlock,
  mergeBlock,
  t,
} from "@easy-email-pro-core/utils";

import { BasicType, ElementCategory } from "@easy-email-pro-core/constants";
import {
  ContentWidgetElement,
  ElementDefinition,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BlockRenderer } from "@easy-email-pro-core/components";
import { cloneDeep } from "lodash";

const defaultData: ElementDefinition<ContentWidgetElement>["defaultData"] = {
  attributes: {},
  data: {
    description: "",
    config: [],
    input: {},
  },
};

export const ContentWidget = createBlock<ContentWidgetElement>({
  get name() {
    return t("Widget");
  },
  void: true,
  defaultData,
  type: BasicType.CONTENT_WIDGET,
  create: (payload) => {
    const data: ContentWidgetElement = {
      type: BasicType.CONTENT_WIDGET,
      title: "MY FIRST WIDGET",
      data: {
        ...defaultData.data,
      },
      attributes: {},
      children: [{ text: "" }],
    };
    return mergeBlock(data, payload);
  },
  get category() {
    return ElementCategory.UNKNOWN_CONTENT;
  },
  render(params) {
    const { node } = params;
    const blockData = cloneDeep(node.children[0]);

    if (!NodeUtils.isElement(blockData)) return null;

    return <BlockRenderer {...params} node={blockData} />;
  },
});
